class HeaderCtrl {
  constructor($window, $interval, $rootScope, $scope, $uibModal, firebase, AuthService, FEService, EventService, FlashService, $state) {
    'ngInject';
    Object.assign( this, { $window, $interval, $rootScope, $scope, $uibModal,firebase, $state });
    this.as = AuthService;
    this.fe = FEService;
    this.es = EventService;
    this.fs = FlashService;

    this.user = undefined;
    this.realm = "Loading";
    this.messageCount = 0;
    this.showSpark = false;
  }

  async $onInit() {
    [this.user, this.realm, this.PROVIDER] = await Promise.all([
      this.as.user(),
      this.as.realm(),
      this.as.getProviderSettings()
    ]);
    this.providerDomain = this.PROVIDER.domain;
    this.appName = this.fe.isDevMode ? this.firebase?.app()?.options?.projectId: '';
    
    if (await this.as.isExpiredSession()){
      this.as.logout();
    }

    this.$rootScope["userMessages"] = [];
    try {
      await this.getActiveMessages();
    }
    catch(e) {
      this.fs.error("Couldn't obtain user messages!");
      console.error(e);
    }

    // refresh user messages every hour
    this.$interval(_ => this.getActiveMessages(), 3600000);
  }

  $onDestroy() {
    this.es.disposeSubscribers("builder_menu");
  }

  openUserGuide() {
    this.$window.open("https://formengine.freshdesk.com/support/solutions", "_blank");
  }

  openSupportForm() {
    this.$window.open("https://formengine.freshdesk.com/support/tickets/new", "_blank");
  }

  toggleSpark(){
    this.showSpark = !this.showSpark;
  }
  
  async getActiveMessages() {
    const response = await this.fe.httpsCallable('getActiveMessages');
    const { data: { totalMessages = 0, messages = [], realmId = "" } = {} } = response || {};
    const activeMessages = { count: totalMessages, list: messages };

    this.$rootScope["userMessages"] = activeMessages;
    this.$rootScope["realmId"] = realmId;
    this.messageCount = activeMessages.list.filter(m => m.type != 'Banner').length;

    this.es.subscribeEvent(
      this.es.actions.USER_MESSAGE_SELECTED, 
      data => this.showUserMessages(data.messageId), 'USER_MESSAGE_SELECTED_HD'
    );
  }

  showUserMessages(messageId) {
    this.messageId = messageId;
    
    const uibModal = { scope: this.$scope, size: "lg control-modal", backdrop: true };
    uibModal.template =
      `<user-notification
        message-id="$ctrl.messageId"
        cancel-modal="$ctrl.cancelModal()">
      </user-notification>`;
    
    this.modal = this.$uibModal.open(uibModal);
    this.modal.result.then(
      closed => this.cancelModal(),
      canceled => this.cancelModal()
    );
  }

  cancelModal() {
    this.modal.dismiss("Canceled");
  }
}

export default {
  bindings: {},
  templateUrl: 'layout/header/header.component.html',
  controller: HeaderCtrl
}
